import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';
import { FieldRenderProps } from 'react-final-form';

export default ({
  input: { name, onChange, value, ...restInput },
  maxLength,
  meta,
  label,
  labelClassName,
  select,
  selectItems,
  ...rest
}: FieldRenderProps<string | number>) => (
  <FormGroup>
    <FormControlLabel
      control={
        <Checkbox
          {...rest}
          name={name}
          inputProps={{ ...restInput, maxLength }}
          onChange={onChange}
          value={value}
        />
      }
      label={label}
      classes={{ label: labelClassName }}
    />
    {Boolean(meta) && meta.touched && meta.error && (
      <FormHelperText margin="dense" className="mt-0 mb-3" error>
        {meta.touched ? meta.error : undefined}
      </FormHelperText>
    )}
  </FormGroup>
);
